import Image from "next/image"
import Link from "next/link"
import { PointAmount } from "./point-amount.tsx"

type ConsumerProductCardModel = {
  readonly available: boolean
  readonly id: string
  readonly imageUrl: string
  readonly name: string
  readonly priceWon: number
}

export const ConsumerProductCard = ({ product }: { readonly product: ConsumerProductCardModel }) => (
  <article className="consumer-product-card" data-availability={product.available ? "AVAILABLE" : "UNAVAILABLE"} data-product-id={product.id}>
    <Link aria-disabled={!product.available} className="consumer-product-card-link" href={product.available ? `/products/${product.id}` : "#"}>
      <span className="consumer-product-media">
        <Image alt={product.name} height={250} sizes="(max-width: 48rem) 5rem, 9rem" src={product.imageUrl} unoptimized width={250} />
      </span>
      <span className="consumer-product-copy">
        <strong className="consumer-product-name">{product.name}</strong>
        <span className="consumer-product-meta">
          <strong className="consumer-product-price">
            <PointAmount amount={product.priceWon} />
          </strong>
        </span>
      </span>
    </Link>
  </article>
)
